module.exports = __webpack_public_path__ + "static/img/contact.903d0fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact.png
// module id = 550A
// module chunks = 1